import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Phone, Mail, MapPin } from 'lucide-react';
import { clubInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="bg-[#302f2c] text-[#dfddd6] py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_fight-evolution-2/artifacts/yp7kukjz_Untitled%20design.png" 
                alt="NexGen MMA Logo" 
                className="h-14 w-14 object-contain rounded-full"
                style={{ mixBlendMode: 'lighten' }}
              />
              <h3 className="text-[#d9fb06] font-black text-xl uppercase leading-tight">
                NexGen MMA
              </h3>
            </div>
            <p className="text-sm text-[#888680] leading-relaxed">
              {clubInfo.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#d9fb06] font-semibold uppercase text-sm mb-4 tracking-wide">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-[#d9fb06] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-sm hover:text-[#d9fb06] transition-colors">
                  Courses
                </Link>
              </li>
              <li>
                <Link to="/schedule" className="text-sm hover:text-[#d9fb06] transition-colors">
                  Schedule
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-[#d9fb06] transition-colors">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#d9fb06] font-semibold uppercase text-sm mb-4 tracking-wide">
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-sm">
                <Phone size={16} className="text-[#d9fb06]" />
                <a href={`tel:${clubInfo.phone}`} className="hover:text-[#d9fb06] transition-colors">
                  {clubInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-2 text-sm">
                <Mail size={16} className="text-[#d9fb06]" />
                <a href={`mailto:${clubInfo.email}`} className="hover:text-[#d9fb06] transition-colors">
                  {clubInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-2 text-sm">
                <MapPin size={16} className="text-[#d9fb06] mt-1 flex-shrink-0" />
                <span>{clubInfo.location}</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-[#d9fb06] font-semibold uppercase text-sm mb-4 tracking-wide">
              Follow Us
            </h4>
            <a
              href={clubInfo.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 text-sm hover:text-[#d9fb06] transition-colors"
            >
              <Instagram size={20} className="text-[#d9fb06]" />
              <span>@nexgenmmaclub</span>
            </a>
          </div>
        </div>

        <div className="border-t border-[#3f4816] mt-8 pt-6 text-center">
          <p className="text-sm text-[#888680]">
            © {new Date().getFullYear()} NexGen MMA Club. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
